// extracted by mini-css-extract-plugin
export default {"infoPanel":"infoPanel_infoPanel__6c6qp"};